import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { PotInfo } from '../shared/types';

export function PotDisplay({ pots, pulseOnGrow }: { pots: PotInfo[]; pulseOnGrow?: boolean }) {
  const total = pots.reduce((s, p) => s + p.amount, 0);
  const prevTotal = useRef(total);
  const [pulseKey, setPulseKey] = useState(0);

  useEffect(() => {
    if (pulseOnGrow && total > prevTotal.current) {
      setPulseKey((k) => k + 1); // меняем key -> форсируем перезапуск анимации "золотого всплеска"
    }
    prevTotal.current = total;
  }, [total, pulseOnGrow]);

  if (total <= 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      className="relative flex flex-col items-center gap-0.5"
    >
      <motion.div
        key={pulseKey}
        initial={pulseKey > 0 ? { scale: 1.3, boxShadow: '0 0 0px rgba(224,182,74,0)' } : false}
        animate={{ scale: 1 }}
        transition={{ type: 'spring', stiffness: 300, damping: 15 }}
        className="px-3 py-1 rounded-full bg-ink-900/80 border border-gold-500/30 backdrop-blur-sm"
      >
        <span className="text-gold-400 font-semibold text-sm tabular-nums">
          Банк: {total.toLocaleString('ru-RU')}
        </span>
      </motion.div>
      {pots.length > 1 && (
        <div className="text-[10px] text-white/40">{pots.length} побочных банка</div>
      )}
    </motion.div>
  );
}
